export const latlng = {
  lat: 41.575335241163046,
  lng: -85.83142197895535,
};

export const email = 'kiwanis.tools4schools@gmail.com';
